// extracted by mini-css-extract-plugin
export default {"itemsFormCheckbox":"ModelItemStyle_itemsFormCheckbox__RfvCI"};